import { MsalService } from "@azure/msal-angular";
import { IPublicClientApplication, PublicClientApplication } from "@azure/msal-browser";
import { environment } from "src/environments/environment";
import { AuthService } from "../services/auth-service/auth.service";

export function initializeMsal(authService: AuthService, msalService: MsalService): () => Promise<void> {
  return async () => {
    await msalService.instance.initialize();
    await authService.handleRedirect();
  };
}
export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msClientId, // Replace with your Application ID
      authority: 'https://login.microsoftonline.com/f129bd96-bdd0-437a-a6c0-bcce2c450aae', // Replace with your Tenant ID
      redirectUri: environment.xappUrl, //For firebase
      // redirectUri: 'http://localhost:4200', //For local development
      // navigateToLoginRequestUrl: false
    },
    cache: {
      // cacheLocation: 'localStorage',
      storeAuthStateInCookie: isIE() // Set to true for IE11 or Edge
    }
  });
}



function isIE(): boolean {
  const ua = window.navigator.userAgent;
  return ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
}
